import { render, staticRenderFns } from "./CompositeItem.vue?vue&type=template&id=a493a7fa&scoped=true"
import script from "./CompositeItem.vue?vue&type=script&lang=js"
export * from "./CompositeItem.vue?vue&type=script&lang=js"
import style0 from "./CompositeItem.vue?vue&type=style&index=0&id=a493a7fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a493a7fa",
  null
  
)

export default component.exports